// extracted by mini-css-extract-plugin
export var brand = "_8q-9";
export var compact = "_8q-6";
export var extraSmall = "_8q-7";
export var icon = "_8q-0";
export var large = "_8q-4";
export var light = "_8q-1";
export var medium = "_8q-5";
export var outline = "_8q-b";
export var primaryDark = "_8q-a";
export var primaryLight = "_8q-8";
export var primaryModern = "_8q-c";
export var success = "_8q-2";
export var successSolid = "_8q-3";